/** Modos HVAC: en Samsung ST el ventilador-solo se llama `wind`; en UI SHC se muestra como `fan`. */

export const AC_MODES_UI = ['auto', 'cool', 'heat', 'fan', 'dry'] as const;
export const FAN_MODES_UI = ['auto', 'low', 'medium', 'high'] as const;

export function displayHvacMode(mode: string | null | undefined): string {
  if (!mode) return '—';
  const m = String(mode).toLowerCase();
  if (m === 'wind') return 'fan';
  return m;
}

/** Valor seleccionado en UI a partir del estado ST. */
export function uiHvacModeValue(mode: string | null | undefined): string {
  return displayHvacMode(mode) === '—' ? '' : displayHvacMode(mode);
}

/** Valor a enviar a ST desde la UI. */
export function stHvacModeValue(uiMode: string): string {
  const m = String(uiMode).toLowerCase();
  if (m === 'fan') return 'wind';
  return m;
}

/** En modo dry el AC solo admite ventilador Auto. */
export function availableFanModes(hvacMode: string | null | undefined): readonly string[] {
  return uiHvacModeValue(hvacMode) === 'dry' ? (['auto'] as const) : FAN_MODES_UI;
}
